import React from "react";
import "./DotFlashing.css";

const DotFlashing: React.FC = () => {
    return (
        <div className="dot-flashing"></div>
    )
}

export default DotFlashing;